module.exports = __webpack_public_path__ + "static/media/how-to-use.39b1afa8.jpg";